<template>
	<div>
		<h1>Pagina niet gevonden</h1>
		Klik <nuxt-link to="/"> hier </nuxt-link> om terug te gaan
	</div>
</template>
